import moment from "moment";

const CONSTANT = {
    URL_CHECK_VALIDATION_MEMBER_PERSON: '/member/check-validation-person',
    URL_CHECK_VALIDATION_MEMBER_UPDATE_PERSON: '/member/check-validation-update-person',
    URL_CHECK_VALIDATION_BID_MEMBER_PERSONAL: '/member/check-validation-bid-personal',
    URL_CHECK_VALIDATION_PRICE_STEP: '/admin/setting/check-price-step',
    URL_CREATE_MEMBER_PERSON: '/member/create-member-person',
    URL_DUPLICATE_PRODUCT: '/admin/product/duplicate-product',
    URL_IMPORT_PRODUCT: '/admin/product/import',
    URL_PRODUCT_TOP: '/admin/product',
    URL_CHECK_VALIDATION_AUCTION: '/admin/auction/check-validation',
    URL_CHECK_VALIDATION_PRODUCT: '/admin/product/check-validation',
    URL_CHECK_VALIDATION_MEMBER_UPDATE: '/admin/member/check-validation-update',
    URL_CHECK_VALIDATION_REFUND: '/admin/member/check-validation-refund',
    URL_CHECK_VALIDATION_MEMBER_CREATE: '/admin/member/check-validation-create',
    URL_CREATE_NOTE_PRODUCT: '/member/storeProductNote',
    URL_IMPORT_AUCTION_PRODUCT_END_BID_TIME: '/admin/auction/import-product-end-bid-time',
    URL_GET_ADDRESS: '/member/get-address',
    URL_GET_ADDRESS_ADMIN: '/admin/member/get-address',
    URL_GET_MEMBER_BY_NUMBER: '/admin/auction/get-member',
    URL_CREATE_MEMBER_PADORU: '/admin/auction/padoru/create',
    URL_CHECK_VALIDATION_AUCTION_MEMBER: '/admin/auction/padoru/check-validate',
    URL_GET_AUCTION_MEMBER: `/admin/auction`,
    URL_CHECK_BARGAIN: `/admin/auction/bargain/check`,
    URL_GET_BARGAIN: `/admin/auction`,
    URL_CHECK_VALIDATION_REJECT_BARGAIN: '/admin/auction/bargain/check-validate',
    URL_GET_MEMBER_BARGAIN: '/member/bargain',
    URL_REMOVE_FAVORITE: '/invoice/removeFavorite',
    URL_ADD_FAVORITE: '/invoice/addFavorite',
    URL_CHECK_VALIDATION_INVOICE: '/admin/member/check-validation-invoice',
}

const DEFAULT_LOCALE_PROPERTIES = {
    applyLabel: '適用',
    cancelLabel: 'キャンセル',
    daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    format: 'YYYY/MM/DD',
    firstDay: 1
}

const COMMON = (function () {
    let modules = {};

    modules.maxSizeImageUpload = 10485760;

    modules.callApi = function (url, type, datatype, data) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        const config = datatype === 'JSON' ? {
            url: url,
            type: type,
            dataType: datatype,
            data: data,
        } : {
            url: url,
            type: type,
            data: data,
            contentType: false,
            processData: false
        }
        return $.ajax(config);
    }

    modules.showError = function (err, element) {
        return err ? $(element).empty().append(err.shift()) : '';
    }

    modules.formatIndex = function (errors) {
        for (let key in errors) {
            if (key.includes('.')) {
                let newKey = key.replace(/\./g, "_");
                errors[newKey] = errors[key];
                delete errors[key];
            }
        }
        return errors;
    }

    modules.showErrorMultiple = function (errors, element) {
        if (errors && Array.isArray(errors)) {
            const errorMessages = errors.join('<br>');
            $(element).html(errorMessages);
        } else {
            $(element).empty();
        }
    };

    modules.validateSizeFileImage = function (element, [textError, elementError, elementHover], elementPreviewImage) {
        $(document).on('change', element, function () {
            if($(this).val()) {
                let sizeImage = this.files[0].size
                $(elementError).empty();
                if(sizeImage >= COMMON.maxSizeImageUpload) {
                    $(this).val('');
                    if (elementPreviewImage === '#preview-img-front') {
                        $(elementPreviewImage).attr('src', '/img/backend/member/front_image_default.svg');
                    } else {
                        $(elementPreviewImage).attr('src', '/img/frontend/default_image_file.png');
                    }
                    COMMON.showError([textError], elementError, '#img-front');
                    $(elementHover).addClass('hover-error')
                } else {
                    COMMON.showError(null, elementError, '#img-front');
                    $(elementHover).removeClass('hover-error')
                }
            }
        })
    }

    modules.handleDateRangePicker = function (selector, singleDatePicker = true, minDate = moment(), localeProperties = DEFAULT_LOCALE_PROPERTIES) {
        $(selector).daterangepicker({
            autoUpdateInput: false,
            singleDatePicker: singleDatePicker,
            showDropdowns: true,
            minDate: minDate,
            locale: localeProperties,
        });

        $(selector).on('apply.daterangepicker', function(_ev, picker) {
            $(this).val(picker.startDate.format('YYYY/MM/DD'));
        });

        $(selector).on('cancel.daterangepicker', function() {
            $(this).val('');
        });
    }

    modules.handlePriceTaxAndServiceFee = function (pricePresent, serviceFee, tax) {
        return pricePresent + (pricePresent * serviceFee) + (pricePresent * serviceFee * tax);
    }

    modules.handleFormatPrice = function (price) {
        return price ? price.toLocaleString(undefined, {maximumFractionDigits: 0}) : 0;
    }

    modules.maximumCharacterLimitPrice = function (price) {
        if (price.length > 14) {
            price = price.slice(0, 14);
        }
        return price;
    }

    modules.handleFormatDate = function (time) {
        let date = new Date(time);
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
        let hours = String(date.getHours()).padStart(2, "0");
        let minutes = String(date.getMinutes()).padStart(2, "0");
        let seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    }

    modules.handleCountDownTime = function (endBidPreBidTime, prebidEndTime, prebidStartTime, interval) {
        let endTime = endBidPreBidTime !== null ? endBidPreBidTime : prebidEndTime;

        let distance = -1;
        let start = new Date(prebidStartTime).getTime();
        let end = new Date(endTime).getTime();
        let timeJapan = new Date().toLocaleString("en-US", {timeZone: "Asia/Tokyo"});
        let now = new Date(timeJapan).getTime();

        if (start > now || end < now) {
            distance = -1;
        } else {
            distance = end - now
        }

        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            clearInterval(interval);
            return "0 : 0 : 0 ";
        }

        return (days ? (days + "日 - ") : '') + (hours < 10 ? '0' + hours : hours) + " : " + (minutes < 10 ? '0' + minutes : minutes) + " : " + (seconds < 10 ? '0' + seconds : seconds);
    }

    modules.countDuplicateBidAmount= function (itemHistories, itemCreateAt, itemAmountBid, amoundBid) {
        let countBidDuplicate = 0;
        let items = document.querySelectorAll(itemHistories);
        items.forEach(item => {
            item.querySelector(`${itemCreateAt} span`).innerText = "";
            let amountBid = item.querySelector(itemAmountBid).innerText.trim();
            if(amountBid === this.formatPrice(amoundBid)) {
                countBidDuplicate ++;
            }
        });

        if(countBidDuplicate !== 1) {
            for(const item of items) {
                let countItem = item.querySelector(`${itemCreateAt} span`);
                let amountItem = item.querySelector(itemAmountBid).innerText;
                if(amountItem === this.formatPrice(amoundBid)) {
                    countItem.textContent = ` (${countBidDuplicate --}位)`;
                } else {
                    break;
                }
            }
        }
    }

    modules.formatPrice = function (price) {
        return price ? price.toLocaleString(undefined, {maximumFractionDigits: 0}) : 0;
    }

    modules.extractAndParseNumber = function(value) {
        if (typeof value !== 'string') {
            value = String(value);
        }
        const numericPart = value.match(/\d+/g);
        if (numericPart) {
            return parseInt(numericPart.join(""), 10);
        }
        return null;
    }

    modules.isNumber = function (event) {
        let input = event.target;
        let value = input.value;

        // Replace any non-numeric character
        input.value = value.replace(/\D/g, '');
    }

    return modules;
})(window.jQuery, window, document);

$(document).ready(function () {

});

export {COMMON, CONSTANT, DEFAULT_LOCALE_PROPERTIES};
